export const Command = {
   Create:1,
   CopyOne:2,
   CopyAll:3,
   CopyTo:4,
   Modify:5,
   OpenReleased:6,
   CancelOrder:7
}